import { Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./Component/Dashboard/Dashboard";
import Sidebar from "./Component/SliderBar/SideBar";
import TopBar from "./Component/TopBar/TopBar";
import Products from "./Component/Product/Product";
import UsersList from "./Component/User/User";
import AddProduct from "./Component/Product/AddSingleCatalog";
import Categories from "./Component/Categories/Categories";
import SizeGuide from "./Component/SizeGuide/SizeGuides";
import OffersAdd from "./Component/Offers/OffersAdd";
import OfferList from "./Component/Offers/OfferList";
import OrderManage from "./Component/OrderManage/OrderManage";
import AdminLogin from "./Component/AdminLogin/AdminLogin";
import PrivateRoute from "./PrivateRoutes";
import RoleManagement from "./Component/RoleManagement/RoleManagement";
import AdminCreate from "./Component/AdminCreate/AdminCreate";
import NotificationForm from "./Component/Notification/Notification";
import "./App.css";
import PageEditor from "./Component/PageEditor/PageEditor";
import Banner from "./Component/Banner/Banner";
import ImageInchesDownloadAndTag from "./TagCreate";
import ProductDetailsStep from "./Component/Product/ProductDetails/ProductDetailsStep";
import CatalogList from "./Component/Catalogs/CatalogList";
import CatalogDetailPage from "./Component/Catalogs/CatalogDetailPage";
import OrderDetailsPage from "./Component/OrderManage/OrderDetailsPage";
import RefundsPage from "./Component/RefundsPage/RefundsPage";

function App() {
  const location = useLocation();

  const showLayout =
    location.pathname === "/login" ||
    location.pathname === "/add-single-catalog" ||
    location.pathname.startsWith("/catalog/edit/") ||
    location.pathname.startsWith("/catalogs-view/");

  return (
    <div className="d-flex">
      {!showLayout && <Sidebar />}

      <div
        className={`${showLayout ? "w-100" : "main-content flex-grow-1 p-3"}`}
      >
        {!showLayout && <TopBar />}
        <div className="p-3">
          <Routes>
            <Route path="/login" element={<AdminLogin />} />

            {/* Protected Routes */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/tag"
              element={
                <PrivateRoute>
                  <ImageInchesDownloadAndTag />
                </PrivateRoute>
              }
            />
            <Route
              path="/products"
              element={
                <PrivateRoute>
                  <Products />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-single-catalog"
              element={
                <PrivateRoute>
                  <AddProduct />
                  {/* <ProductDetailsStep /> */}
                </PrivateRoute>
              }
            />
            <Route
              path="/catalog/edit/:catalogId"
              element={
                <PrivateRoute>
                  <ProductDetailsStep />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <UsersList />
                </PrivateRoute>
              }
            />
            <Route
              path="/categories"
              element={
                <PrivateRoute>
                  <Categories />
                </PrivateRoute>
              }
            />
            <Route
              path="/sizeguide"
              element={
                <PrivateRoute>
                  <SizeGuide />
                </PrivateRoute>
              }
            />
            <Route
              path="/catalogs"
              element={
                <PrivateRoute>
                  <CatalogList />
                </PrivateRoute>
              }
            />
            <Route
              path="/catalogs-view/:id"
              element={
                <PrivateRoute>
                  <CatalogDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/changes-offers"
              element={
                <PrivateRoute>
                  <OffersAdd />
                </PrivateRoute>
              }
            />
            <Route
              path="/offers"
              element={
                <PrivateRoute>
                  <OfferList />
                </PrivateRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <PrivateRoute>
                  <OrderManage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/order/:id"
              element={
                <PrivateRoute>
                  <OrderDetailsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/refund-page"
              element={
                <PrivateRoute>
                  <RefundsPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/role-management"
              element={
                <PrivateRoute>
                  <RoleManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin-management"
              element={
                <PrivateRoute>
                  <AdminCreate />
                </PrivateRoute>
              }
            />
            <Route
              path="/notification"
              element={
                <PrivateRoute>
                  <NotificationForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pages-editor"
              element={
                <PrivateRoute>
                  <PageEditor />
                </PrivateRoute>
              }
            />
            <Route
              path="/banner"
              element={
                <PrivateRoute>
                  <Banner />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
